import { render } from "./EditWorkShift.vue?vue&type=template&id=5654dcf1&scoped=true"
import script from "./EditWorkShift.vue?vue&type=script&lang=js"
export * from "./EditWorkShift.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=5654dcf1&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5654dcf1"]])

export default __exports__